import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import useAdminUser from '../hooks/useAdminUser';
import { USER_ROUTES, ADMIN_ROUTES } from '../constants/routeConstants';

/**
 * Public/Guest-only Route component.
 * Redirects authenticated users or admins away from auth-only pages (like login/register).
 */
const PublicRoute = ({ children, type = 'user' }) => {
  const { user } = useAuth();
  const { adminUser } = useAdminUser();

  if (type === 'admin') {
    if (adminUser) {
      return <Navigate to={ADMIN_ROUTES.DASHBOARD} replace />;
    }
  } else {
    if (user) {
      return <Navigate to={USER_ROUTES.DASHBOARD} replace />;
    }
  }

  return children;
};

export default PublicRoute;
